import { LitElement, html, css } from 'lit';
import { sharedStyles } from './base.js';

// <gt-section-header label="Movers" sublabel="Top 10 by % change">
//   <a slot="actions" href="/pulse/">All</a>
// </gt-section-header>
export class GtSectionHeader extends LitElement {
  static properties = {
    label: { type: String },
    sublabel: { type: String },
  };
  static styles = [
    sharedStyles,
    css`
      :host {
        display: block;
      }
      .row {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: var(--space-3, 12px);
        padding-bottom: var(--space-2, 8px);
        border-bottom: 1px solid var(--border, #1e2535);
        margin-bottom: var(--space-4, 16px);
      }
      .titles {
        display: flex;
        align-items: baseline;
        gap: var(--space-3, 12px);
        flex-wrap: wrap;
      }
      .title {
        font-size: var(--fs-lg, 1.25rem);
        font-weight: 600;
        letter-spacing: -0.01em;
        color: var(--text-strong, #e8dfc0);
      }
      .sub {
        font-size: var(--fs-xs, 0.72rem);
        color: var(--muted, #94a3b8);
      }
      ::slotted([slot='actions']) {
        font-size: var(--fs-xs, 0.72rem);
        color: var(--accent, #c8a84b);
        text-decoration: none;
      }
    `,
  ];
  render() {
    return html`
      <div class="row">
        <div class="titles">
          <span class="title">${this.label}</span>
          ${this.sublabel ? html`<span class="sub">${this.sublabel}</span>` : null}
        </div>
        <slot name="actions"></slot>
      </div>
    `;
  }
}
customElements.define('gt-section-header', GtSectionHeader);
